import { _, Backbone, $ } from "js/vendor";
import { DebugBox } from "js/elements/elements/DebugBox";

class CanvasLayouter {
    constructor(canvas, template) {
        _.extend(this, Backbone.Events);

        this.canvas = canvas;
        this.template = template;

        this.elements = {};
    }

    destroy() {
        this.clearElements();
        this.stopListening();

        return null;
    }

    clearElements() {
        _.each(this.elements, element => {
            element.remove();
        });
    }

    get primaryElement() {
        return this.elements.primary;
    }

    render() {
        // to be overridden
    }

    createElement(id, elementClass) {
        if (!elementClass) elementClass = DebugBox;

        this.model.elements[id] = this.model.elements[id] || {};

        if (this.elements[id]) return this.elements[id];

        let element = new (elementClass)({
            id: id,
            canvas: this.canvas
        });
        this.elements[id] = element;

        return element;
    }

    removeElement(id) {
        let element = this.elements[id];

        // remove the element data from the slide model ( added because turning off the secondaryRegion was leaving previous state in the model which caused oddities when turning secondary region back on)
        //this.slide.liveDataState.unset(id);

        if (element) {
            delete this.elements[id];
            delete this[id];

            $(element.svg.node).velocity("transition.fadeOut", {
                complete: () => {
                    element.svg.remove();
                }
            });
        }
    }

    clear() {
        // _.each(this.elements, element => {
        //     element.svg.remove();
        // });
        this.elements = {};
    }

    // reload() {
    //     // Promise.resolve().then() will guarentee that the promise is resolved or rejected even if the then code crashes.
    //     return Promise.resolve().then(() => {
    //         this.canvas.canvasDecoration = null;
    //         this.canvas.overlayDecoration = null;
    //         this.canvas.removeAllElements();
    //         if (!this.canvas.isRendered) {
    //             console.log("canvas not rendered");
    //             return;
    //         }
    //         this.canvas.svg.clear();
    //         this.elements = {};
    //         this.render(false);
    //         return this.canvas.loaded().then(() => {
    //             let calculatedLayout = this.calcLayout();
    //             this.layout(calculatedLayout, false);
    //         });
    //     });
    //
    // }
    //
    // refreshLayout(animate) {
    //     this.elements.primary.clearCachedCalculatedLayouts();
    //     let calculatedLayout = this.calcLayout();
    //     if (calculatedLayout.isFit) {
    //         this.layout(calculatedLayout, animate);
    //     }
    // }
}

export { CanvasLayouter };
